import { MESSAGE_ID_ATTR } from 'conversations-message-history/web/message-history/constants/constants';
export const getDOMNodeByMessageId = messageId => document.querySelector(`[${MESSAGE_ID_ATTR}="${messageId}"]`);